<script>
import api from "@/api";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ManageTimeslotsModal from "../components/ManageTimeslotsModal.vue";
import GameModal from "@/components/GameModal";
import ScheduleConfigurationDialogs from "@/components/ScheduleConfigurationDialogs.vue";
import TournamentConfigurationDialogs from "@/components/TournamentConfigurationDialogs.vue";
import jaLocale from "@fullcalendar/core/locales/ja";

export default {
  components: {
    TournamentConfigurationDialogs,
    ScheduleConfigurationDialogs,
    FullCalendar,
    ManageTimeslotsModal,
    GameModal,
  },
  props: ["calinfo"],
  data: function() {
    return {
      calendarSettings: {
        interval: localStorage.getItem("slotDuration") || "00:05:00",
        start: localStorage.getItem("slotMinTime") || "00:00:00",
        finish: localStorage.getItem("slotMaxTime") || "23:55:00",
        locales: [jaLocale],
        locale: this.$i18n.locale == "ja" ? jaLocale : "en",
      },
      settingsModal: false,
      gameModal: false,
      showSidebar: true,
      endDialog: false,
      endSlotDate: null,
      a1: null,
      a2: null,
      keyBusy: false,
      pasting: false,
      scheduleBusy: false,
      configDialog: false,
      tournamentDialog: false,
      tournamentAdditionalDialog: false,
      tournamentScheduleDialog: false,
      scheduleDialog: false,
      configAdditionalDialog: false,
      venueBalanceDialog: false,
      sconfig: {
        title: "",
        startDate: null,
        endDate: null,
        division_id: [],
        mode: 0,
        style: 0,
        count: 2,
        time: {
          days: 0,
          weeks: 0,
        },
        min_minutes_rest: 0,
        next_game_offset: 0,
        max_games_day: 1,
        max_games_week: 0,
        use_coach_conflict_method: true,
        do_balance: false,
        enforce_home: true,
        balance_venues: false,
        realStart: null,
        realEnd: null,
        venue_balance_method: 0,
        venue_balance_tolerance: 0,
        // Tournament part
        elimination: "single",
        team_sort: 0,
        is_tournament: false,
      },
      division: null,
      selecting: false,
      schedule_id: null,
      slotLength: localStorage.getItem("calendarInterval") ? parseInt(localStorage.getItem("calendarInterval")) : 90,
      modalType: 0,
      tooltipPosition: {},
      tooltipString: "",
      showTooltip: false,
      tooltipRatio: 1.0,
      action: null,
      showFilters: localStorage.getItem("showFilters") && localStorage.getItem("showFilters").length > 0,
      open: false,
      selectedEventIDs: [],
      shiftDown: false,
      includeMultiDivision: true,
      includeGames: true,
      includePractices: true,
      practiceTimeslots: true,
      gameTimeslots: true,
      includeTimeslots: true,
      isLoading: true,
      selectedTeams: [],
      selectedVenues: [],
      selectedSurfaces: [],
      selectedDivisions: [],
      deleteAllModal: false,
      deleteVisibleModal: false,
      calendar: null,
      weekOptions: [],
      weekTemplate: null,
      weekSelection: null,
      weekModal: false,
      activeEventModal: false,
      activeEvent: null,
      allowTooltip: true,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        locales: [jaLocale],
        locale: this.$i18n.locale == "ja" ? jaLocale : "en",
        firstDay: 0,
        headerToolbar: {
          right: "prev,next",
          center: "title",
          left: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        scrollTimeReset: false,
        height: "95vh",
        contentHeight: "95vh",
        initialView: "dayGridMonth",
        events: [],
        editable: true,
        selectable: true,
        selectMirror: false,
        scrollTime: "12:00:00",
        slotMinTime: localStorage.getItem("slotMinTime") || "00:00:00",
        slotMaxTime: localStorage.getItem("slotMaxTime") || "24:00:00",
        slotDuration: localStorage.getItem("slotDuration") || "00:05:00",
        selectMinDistance: 20,
        dayMaxEvents: true,
        weekends: true,
        allDaySlot: false,
        navLinks: true,
        navLinkDayClick: this.clickHeaderDate,
        viewDidMount: this.viewDidMount,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventDrop: this.handleEventDrop,
        eventResize: this.handleEventDrop,
        dateClick: this.handleDateClick,
        eventsSet: this.handleEvents,
        eventMouseEnter: this.eventMouseEnter,
        eventMouseLeave: this.eventMouseLeave,
        dayCellClassNames: this.dayRender,
      },
      template: {
        venue: null,
        length: localStorage.getItem("calendarInterval") ? parseInt(localStorage.getItem("calendarInterval")) : 90,
        divisions: [],
        surface_ids: [],
        is_practice: true,
        is_game: true,
        is_reserved: false,
      },
      timeslots: [],
      timeslotEvents: [],
      windowWidth: 500,
      showVenueBalanceWindowInfo: false,
    };
  },
  computed: {
    gameTeams() {
      var results = [];
      console.log("Selected Teams: ", this.selectedTeams);
      if (this.currentSeason) {
        this.currentSeason.teams.forEach(t => {
          console.log("Check " + t.id);
          if (this.selectedTeams.includes(t.id)) {
            results.push({ id: t.id, name: t.name });
          }
        });
      }
      return results;
    },
    oldDates() {
      if (this.sconfig.startDate) {
        return [];
      }
      let x = [];
      let today = this.$moment(new Date()).format("YYYY-MM-DD");
      x = [today];
      for (let i = 0; i < 90; i++) {
        let d = this.$moment(today)
          .add(i * -1, "days")
          .format("YYYY-MM-DD");
        x.push(d);
      }
      return x;
    },
    intervalOptions() {
      return [
        { label: this.$t("1-minute"), value: "00:01:00" },
        { label: this.$t("5-minutes"), value: "00:05:00" },
        { label: this.$t("10-minutes"), value: "00:10:00" },
        { label: this.$t("15-minutes"), value: "00:15:00" },
        { label: this.$t("20-minutes"), value: "00:20:00" },
        { label: this.$t("25-minutes"), value: "00:25:00" },
        { label: this.$t("30-minutes"), value: "00:30:00" },
        { label: this.$t("40-minutes"), value: "00:40:00" },
        { label: this.$t("50-minutes"), value: "00:50:00" },
        { label: this.$t("60-minutes"), value: "00:60:00" },
      ];
    },
    endSlotDateFriendly() {
      if (this.endSlotDate) {
        return this.$moment(this.endSlotDate).format("MMM D");
      }
      return "";
    },
    endSlotDateFriendlyPlus() {
      if (this.endSlotDate) {
        return this.$moment(this.endSlotDate).format("MMM D");
        // return this.$moment(this.endSlotDate).add(1,'days').format('MMM D')
      }
      return "";
    },
    scheduleThings() {
      if (this.includeGames && this.includePractices && this.includeTimeslots) {
        return this.$t("calendar-items");
      } else if (this.includeGames && this.includePractices) {
        return this.$t("games-and-practices");
      } else if (this.includeTimeslots && !this.includeGames && !this.includePractices) {
        return this.$t("Timeslot.timeslots");
      } else if (this.includeGames && !this.includePractices && !this.includeTimeslots) {
        return this.$t("item_string.games");
      } else if (!this.includeGames && this.includePractices && !this.includeTimeslots) {
        return this.$t("item_string.practices");
      } else if (this.includeGames && this.includeTimeslots) {
        return this.$t("games-and-timeslots");
      } else if (this.includePractices && this.includeTimeslots) {
        return this.$t("practices-and-timeslots");
      } else {
        return null;
      }
    },
    itemsPerTeam() {
      if (this.sconfig.mode == 1) {
        // Practice
        return this.slotsNeeded ? parseInt(this.slotsNeeded / this.teamCount) : "--";
      } else {
        // Games
        var z = this.slotsNeeded ? parseInt((2 * this.slotsNeeded) / this.teamCount) : "--";
        if (this.division && this.division.is_across) {
          z = z / 2;
        }
        return z;
      }
    },
    teamCount() {
      if (this.division) {
        if (this.division.is_across) {
          console.log(this.a1.teams.length, this.a2.teams.length);
          return Math.min(this.a1.teams.length, this.a2.teams.length);
        }
        return this.division.teams.length;
      }
      return 1;
    },
    visibleItems() {
      if (!this.calendar) {
        return [];
      }
      var x = [];
      var s = this.getApi().view.activeStart;
      var e = this.getApi().view.activeEnd;
      this.timeslots.forEach(t => {
        var ts = new Date(t.start);
        var te = new Date(t.finish);
        if (ts >= s && te <= e && this.selectedEventIDs.indexOf(t.id) < 0) {
          x.push(t);
        }
      });
      return x;
    },
    scheduleSummary() {
      if (!this.configValid) {
        return "";
      }
      var str = "";
      var z = this.$t("item_string.games");
      if (this.sconfig.mode == 1) {
        z = this.$t("item_string.practices");
      }
      z = "";
      str = z;
      if (this.sconfig.style == 0) {
        str += this.sconfig.count + this.$t("rounds-per-team");
      } else if (this.sconfig.style == 1) {
        str += this.sconfig.count + this.$t("per-team-per-week");
      } else {
        str += this.sconfig.count + " " + z + this.$t("per-team-total");
      }
      str +=
        ", " +
        parseInt((2 * this.slotsNeeded) / this.division.teams.length) +
        this.$t("z-per-team-this-slotsneeded-total", [z, this.slotsNeeded]);
      return str;
    },
    allDivisions() {
      return this.template.divisions.length == 0;
    },
    additionalNeeded() {
      // console.log("AN")
      return Math.max(0, this.slotsNeeded - this.slotsAvailable(this.sconfig.division_id));
    },
    weeksNeeded() {
      if (!this.sconfig.use_weekend_method) return 0;
      const totalWeeks = Math.ceil(this.itemsPerTeam / 2);
      return totalWeeks > this.seasonDates.weeks ? totalWeeks - this.seasonDates.weeks : 0;
    },
    configValid() {
      if (this.weeksNeeded > 0) return false;
      return !!this.sconfig.startDate && !!this.sconfig.endDate && !!this.sconfig.division_id && !!this.sconfig.count;
    },
    tournamentValid() {
      return (
        !!this.sconfig.startDate &&
        !!this.sconfig.endDate &&
        !!this.sconfig.division_id &&
        (Math.log(this.teamCount) / Math.log(2)) % 1 === 0
      );
    },
    slotsNeeded() {
      if (this.sconfig.startDate && this.sconfig.endDate && !!this.division) {
        let w = this.seasonDates.weeks;
        let t = this.teamCount;

        if (this.sconfig.is_tournament) {
          const single = t - 1;
          const double = 2 * t - 1;
          return this.sconfig.elimination === "single" ? single : double;
        } else {
          let c = this.sconfig.count;
          let n = 0;
          switch (this.sconfig.style) {
            // Rounds
            case 0:
              n = (c * (t * (t - 1))) / 2;
              if (this.division.is_across) {
                n = (c * (this.a1.teams.length * this.a2.teams.length)) / 2;
              }
              break;
            // Weeks
            case 1:
              // d.config.max_games_week = c
              let z = (c * t * w) / 2;
              // console.log("Weeks --> ", c, t, w, z)
              n = z;
              break;
            case 2:
              // Total
              n = Math.ceil((c * t) / 2);
              break;
          }
          if (this.division.is_across) {
            n = n * 2;
          }

          n = Math.max(1, Math.ceil(n));

          if (this.sconfig.mode === 1) {
            console.log("Practice Mode....double");
            n = n * 2;
          }
          return Math.max(0, n);
        }
      }
      return 1;
    },
    seasonDates() {
      if (this.sconfig.startDate && this.sconfig.endDate) {
        const date1 = Date.parse(this.sconfig.realStart);
        const date2 = Date.parse(this.sconfig.realEnd);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        var w1 = this.$moment(date1);
        var w2 = this.$moment(date2);
        if (w2 == 53) {
          w2 = 0;
        }
        if (w1 == 53) {
          w1 = 0;
        }
        // console.log(w1, w2)
        return {
          days: diffDays,
          weeks: w2.diff(w1, "week") + 1,
        };
      }
      return {
        weeks: 0,
        days: 0,
      };
    },
    folders() {
      var games = [];
      var timeslots = [];
      this.timeslotEvents.forEach(e => {
        if (e.has_game) {
          games.push(e);
        } else {
          timeslots.push(e);
        }
      });
      return { games: games, timeslots: timeslots };
    },
    lengthOptions() {
      var i = 5;
      var x = [];
      while (i < 600) {
        x.push({ name: i + this.$t("minutes"), value: i });
        i += 5;
      }
      return x;
    },
    selectedCounts() {
      var games = [];
      var timeslots = [];
      var timeslot_ids = [];
      var game_ids = [];
      this.selectedEvents.forEach(e => {
        if (e.has_game) {
          games.push(e);
          game_ids.push(e.timeslot_id);
        } else {
          timeslots.push(e);
          timeslot_ids.push(e.timeslot_id);
        }
      });
      return {
        games: games,
        timeslots: timeslots,
        timeslot_ids: timeslot_ids,
        game_ids: game_ids,
      };
    },
    selectedEvents() {
      var x = [];
      if (!this.selectedEventIDs.length) {
        return [];
      }
      this.timeslotEvents.forEach(t => {
        if (this.selectedEventIDs.includes(t.timeslot_id)) {
          x.push(t);
        }
      });
      return x;
    },
    weekInfo() {
      if (!this.weekTemplate) {
        return false;
      }
      // Get timeslots in this weeks range
      var count = 0;
      var ws = this.$moment(this.weekTemplate.start);
      var we = this.$moment(this.weekTemplate.end);
      this.timeslotEvents.forEach(e => {
        if (this.$moment(e.start).isBetween(ws, we)) {
          count++;
        }
      });
      var options = [];
      var i = 2;
      while (i < 24) {
        var wen = we.add(1, "weeks");
        options.push({
          name: wen.format("LL") + " - " + i + this.$t("weeks") + i * count + this.$t("new-timeslots"),
          weeks: i,
          endDate: wen,
          timeslots: i * count,
        });
        i++;
      }
      console.log({
        count: count,
        options: options,
      });
      this.weekSelection = options[0];

      return {
        count: count,
        options: options,
      };
    },
  },

  // mmmmmm
  methods: {
    applySettings() {
      console.log("Apply", this.calendarSettings);
      this.calendarOptions.slotMinTime = this.calendarSettings.start;
      localStorage.setItem("slotMinTime", this.calendarOptions.slotMinTime);
      this.calendarOptions.slotMaxTime = this.calendarSettings.finish;
      localStorage.setItem("slotMaxTime", this.calendarOptions.slotMaxTime);
      this.calendarOptions.slotDuration = this.calendarSettings.interval;
      localStorage.setItem("slotDuration", this.calendarOptions.slotDuration);
      if (this.getApi().view.type != "dayGridMonth") {
        document.getElementsByTagName("tbody")[2].style.height = "90vh";
      }
      this.settingsModal = false;
    },
    toggleGameModal(num) {
      this.hideTooltip();
      if (this.gameModal) {
        this.gameModal = false;
        this.activeEvent = null;
        return;
      }

      let item;
      if (num === 0) {
        item = this.selectedCounts.timeslots[0];
      } else {
        item = this.selectedCounts.games[0];
      }
      if (!item) {
        return;
      }

      this.activeEvent = {
        id: item.timeslot_id,
        schedule_id: null,
        open: true,
        timeslot: {
          id: item.timeslot_id,
          start: item.start,
          end: item.end,
          venue_id: item.venue_id,
          surface_id: item.surface_id,
          venue: {
            id: item.venue_id,
          },
          surface: {
            id: item.surface_id,
          },
        },
        venue: {
          id: item.venue_id,
        },
        surface: {
          id: item.surface_id,
        },
        home: {
          id: null,
        },
        visitor: {
          id: null,
        },
        game: item.game,
      };
      if (num === 1) {
        this.activeEvent.home = {
          id: item.game.home_id,
        };
        this.activeEvent.visitor = {
          id: item.game.visitor_id,
        };
      }

      item = this.activeEvent;
      this.po(item, this.$t("item"));
      this.gameModal = true;
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
      setTimeout(() => {
        this.getApi().updateSize();
        console.log("Updates");
      }, 500);
    },
    swapTimeslots() {
      api
        .swapScheduleItems({
          items: this.selectedCounts.game_ids,
        })
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("swapped-games"));
          this.clearSelected(0);
          this.clearSelected(1);
          this.refresh();
        })
        .catch(e => {
          this.makeToast("error", this.$t("could-not-swap-games"));
          console.log(e);
        });
    },
    toggleAll(num) {
      if (num == 0) {
        if (this.selectedDivisions.length) {
          this.selectedDivisions = [];
        } else {
          this.selectedDivisions = [];
          this.$store.getters.currentSeason.divisions.forEach(v => {
            this.selectedDivisions.push(v.id);
          });
        }
      } else if (num == 1) {
        if (this.selectedVenues.length) {
          this.selectedVenues = [];
        } else {
          this.selectedVenues = [];
          this.$store.getters.currentSeason.venues.forEach(v => {
            this.selectedVenues.push(v.id);
          });
        }
      } else if (num == 2) {
        if (this.selectedSurfaces.length) {
          this.selectedSurfaces = [];
        } else {
          this.selectedSurfaces = [];
          this.$store.getters.currentSeason.venues.forEach(v => {
            v.surfaces.forEach(s => {
              this.selectedSurfaces.push(s.id);
            });
          });
        }
      } else if (num == 4) {
        if (this.includePractices || this.includeGames || this.includeMultiDivision || this.includeTimeslots) {
          this.includePractices = false;
          this.includeGames = false;
          this.includeMultiDivision = false;
          this.includeTimeslots = false;
        } else {
          this.includePractices = true;
          this.includeGames = true;
          this.includeMultiDivision = true;
          this.includeTimeslots = true;
        }
      } else if (num == 5) {
        if (this.selectedTeams.length) {
          this.selectedTeams = [];
        } else {
          this.selectedTeams = [];
          this.$store.getters.currentSeason.teams.forEach(v => {
            this.selectedTeams.push(v.id);
          });
        }
      }

      this.setFilteredTimeslots();
    },
    getApi() {
      this.calendar = this.calendar || this.$refs.fullCalendar;
      if (!this.calendar) {
        setTimeout(() => {
          this.calendar = this.calendar || this.$refs.fullCalendar;
          return this.calendar.getApi();
        }, 500);
      } else {
        return this.calendar.getApi();
      }
    },
    viewDidMount() {
      console.log("ViewDidMount");
      if (this.getApi().view.type !== "dayGridMonth") {
        document.getElementsByTagName("tbody")[2].style.height = "90vh";
      }
    },
    dayRender(date, cell) {
      var c = this.sconfig;
      if (c && c.realStart && c.realEnd) {
        var slot = this.$moment(date.date);
        var start = this.$moment(c.realStart).add(-1, "days");
        var end = this.$moment(c.realEnd).add(1, "days");
        if (slot.isBetween(start, end)) {
          return "scheduleDateHighlight";
        }
      }
    },
    finishPasting() {
      this.pasting = false;
      this.clearSelected(0);
      this.clearSelected(1);
    },
    adjustEndDate() {
      const z = this.$moment(this.endSlotDate);
      const e = this.$moment(this.sconfig.realEnd).endOf("day");
      if (z.isAfter(e)) {
        this.setEndDate(z);
      } else {
        this.setStartDate(z);
      }
      this.clearEndDialog();
      this.makeToast("success", this.$t("adjusted-dates-of-schedule"));
    },
    clearEndDialog() {
      this.endDialog = false;
      this.endSlotDate = null;
    },
    tryDeleteKey(event) {
      if (
        this.$route.name == "Calendar" &&
        (event.key == "Delete" || event.key == "Backspace") &&
        this.selectedCounts.timeslots.length
      ) {
        this.keyBusy = true;
        console.log("TRY DELETE");
        this.deleteSelected(0);
      }
    },
    selectVisible() {
      this.visibleItems.forEach(t => {
        if (this.selectedEventIDs.indexOf(t.id) < 0) {
          this.selectedEventIDs.push(t.id);
          this.toggleHighlight(t.id, true);
        }
      });
    },
    selectAll() {
      this.timeslots.forEach(t => {
        if (this.selectedEventIDs.indexOf(t.id) < 0) {
          this.selectedEventIDs.push(t.id);
          this.toggleHighlight(t.id, true);
        }
      });
    },
    submitSchedule() {
      console.log("⭐️ SUBMIT SCHEDULE ⭐️");
      this.scheduleBusy = true;
      this.sconfig.season_id = this.currentSeason.id;
      api
        .createSchedule(this.sconfig)
        .then(response => {
          console.log("Schedule Response", response);
          setTimeout(() => {
            this.goRouter("/schedules/" + response.data.id);
          }, 5000);
        })
        .catch(() => {
          this.scheduleBusy = false;
          alert(
            this.$t(
              "were-sorry-but-something-went-wrong-and-we-werent-able-to-create-your-schedule-support-has-been-notified-please-refesh-and-try-again",
            ),
          );
        });
    },
    cancelSchedule() {
      const type = this.sconfig.is_tournament ? this.$t("tournament") : this.$t("AppMenu.schedule");
      this.sconfig.use_weekend_method = null;
      this.sconfig.friday_as_weekend = null;
      this.division = null;
      this.sconfig.division_id = null;
      this.sconfig.startDate = null;
      this.sconfig.realStart = null;
      this.sconfig.endDate = null;
      this.sconfig.realEnd = null;
      this.sconfig.is_tournament = false;
      this.calendarOptions.validRange = null;
      this.toggleConfigDialog(false);
      this.tournamentDialog = false;
      this.tournamentAdditionalDialog = false;
      this.toggleAdditionalConfigDialog(false);
      this.resetFilters();
      this.makeToast("info", this.$t("type-setup-cancelled", [type]));
    },
    nextSchedule() {
      if (this.sconfig.is_tournament) {
        this.tournamentDialog = false;
        this.tournamentAdditionalDialog = true;
        this.setFilteredTimeslots();
      } else {
        this.toggleConfigDialog(false);
        this.toggleAdditionalConfigDialog(true);
      }
    },
    showVenueBalanceWindow() {
      if (this.sconfig.balance_venues == true) {
        this.toggleVenueBalanceDialog(true);
      }
    },
    toggleConfigDialog(open) {
      if (this.sconfig.is_tournament) {
        this.tournamentDialog = open;
      } else {
        this.configDialog = open;
      }

      if (!open && this.sconfig.division_id) {
        this.showFilters = false;
        this.template.divisions = [this.sconfig.division_id];
        document.getElementById("wizardBox").classList.add("highlight");
        setTimeout(() => {
          document.getElementById("wizardBox").classList.remove("highlight");
        }, 3000);
        this.setFilteredTimeslots();
      }
      if (this.sconfig.style === 1) {
        this.sconfig.max_games_week = this.sconfig.count;
      }
    },
    toggleScheduleDialog(open) {
      if (this.sconfig.is_tournament) {
        this.tournamentScheduleDialog = true;
      } else {
        this.scheduleDialog = open;
        if (open && this.configAdditionalDialog == true) {
          this.configAdditionalDialog = false;
        }
      }
    },
    toggleAdditionalConfigDialog(open) {
      this.configAdditionalDialog = open;
    },
    toggleVenueBalanceDialog(open) {
      this.venueBalanceDialog = open;
      if (open && this.scheduleDialog == true) {
        this.scheduleDialog = false;
      } else {
        this.scheduleDialog = true;
      }
    },
    toggleTournamentConfigDialog(val) {
      this.tournamentAdditionalDialog = !val;
      this.tournamentDialog = val;
    },
    toggleTournamentDialog(val) {
      this.tournamentAdditionalDialog = val;
      this.tournamentDialog = val;
      this.tournamentScheduleDialog = val;
    },
    slotsAvailable(id) {
      console.log("Slots Available: " + this.sconfig.realStart + " ---- " + this.sconfig.realEnd);
      if (!this.folders.timeslots.length) {
        return 0;
      }
      if (!id) {
        return this.folders.timeslots.length;
      }
      var count = 0;
      this.folders.timeslots.forEach(t => {
        // console.log(t)
        var include = false;
        if (this.sconfig.realStart && this.sconfig.realEnd) {
          include = this.dateWithinRange(t.start, this.sconfig.realStart, this.sconfig.realEnd);
        }
        include = include && !t.is_reserved;
        if (include) {
          if ((this.sconfig.mode == 1 && t.is_practice) || (this.sconfig.mode == 0 && t.is_game)) {
            if (!t.divisions || !t.divisions.length) {
              count += 1;
            } else if (t.divisions && t.divisions.indexOf(id) > -1) {
              count += 1;
            }
          }
        } else {
          // console.log("Don't include " + t.start + " because not within range of " + this.sconfig.realStart + " to " + this.sconfig.realEnd)
        }
      });
      return parseInt(count);
    },
    getProgressColor(have, need) {
      var color = "#8b0000";
      if (have >= need) {
        color = "#006400";
      } else if (have / need >= 0.5) {
        color = "black";
      }
      return { color: color };
    },
    eventMouseEnter(e) {
      this.tooltipString = e.event.extendedProps.description;
      this.tooltipPosition.background = e.event.backgroundColor + " !important";
      this.showTooltip = true;
      this.$forceUpdate();
    },
    eventMouseLeave() {
      this.tooltipPosition = {};
      this.showTooltip = false;
      this.$forceUpdate();
    },
    openModal(action, modalType) {
      console.log("OpenModal: " + action + " / " + modalType);
      this.modalType = modalType;
      if (action) {
        this.action = action;
      }
      console.log("Action is now : " + this.action);
      this.hideTooltip();
      this.open = true;
    },
    hideModal() {
      console.log("Hide");
      this.open = false;
      this.showTooltip = false;
    },
    clearSelected(num) {
      console.log("ClearSelected: " + num);
      var results = [];
      var result_ids = [];
      if (num == 0) {
        // Clear timeslots
        this.selectedEvents.forEach(e => {
          console.log(e);
          if (!e.has_game) {
            results.push(e);
            result_ids.push(e.timeslot_id);
          } else {
            this.toggleHighlight(e.timeslot_id, false);
          }
        });
      } else {
        this.selectedEvents.forEach(e => {
          if (e.has_game) {
            results.push(e);
            result_ids.push(e.timeslot_id);
          } else {
            this.toggleHighlight(e.timeslot_id, false);
          }
        });
      }
      this.selectedEventIDs = result_ids;
    },
    unselect(tid) {
      this.selectedEventIDs.splice(this.selectedEventIDs.indexOf(tid), 1);
      this.toggleHighlight(tid, false);
    },
    setStartDate(val) {
      console.log("SetStart", val);
      if (val) {
        this.sconfig.realStart = val;
        this.sconfig.startDate = this.$moment(val).format("L");
      }
      this.getApi().changeView("dayGridMonth", this.sconfig.realStart);
    },
    setEndDate(val) {
      console.log("SetEnd", val);
      if (val) {
        this.sconfig.realEnd = val;
        this.sconfig.endDate = this.$moment(val).format("L");
      }
    },
    resetFilters() {
      this.open = false;
      this.selectedVenues = [];
      this.selectedSurfaces = [];
      this.includeGames = true;
      this.includeTimeslots = true;
      this.includeMultiDivision = true;
      this.$store.getters.currentSeason.venues.forEach(v => {
        this.selectedVenues.push(v.id);
      });
      this.currentSeasonSurfaces.forEach(s => {
        this.selectedSurfaces.push(s.id);
      });
      this.$store.getters.currentSeason.teams.forEach(v => {
        this.selectedTeams.push(v.id);
      });
      if (!this.getURLParam("schedule_id")) {
        this.schedule_id = null;
      }

      this.selectedDivisions = [];
      this.$store.getters.currentSeason.divisions.forEach(v => {
        this.selectedDivisions.push(v.id);
      });
      this.setFilteredTimeslots();
    },
    clickHeaderDate(date, jsEvent) {
      this.getApi().changeView("timeGridDay", date.toISOString());
    },
    doBulk(links) {
      console.log("DoBulk", links);
      api
        .createBulkTimeslots(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", "Created " + response.data.count + " timeslots from CSV  ⭐️");
          this.fetchData();
        })
        .catch(() => {
          alert(this.errors);
        });
    },
    clearAllTimeslots() {
      this.hideTooltip();
      api.clearSeasonTimeslots(this.$store.getters.currentSeason.id).then(() => {
        this.makeToast(
          "success",
          this.$t("deleted-this-timeslotevents-length-timeslots", [this.timeslotEvents.length]),
        );
        this.deleteAllModal = false;
        this.resetFilters();
        this.fetchData();
      });
    },
    clearVisibleTimeslots() {
      var timeslots = [];
      this.timeslotEvents.forEach(t => {
        timeslots.push(t.timeslot_id);
      });
      this.hideTooltip();
      console.log(timeslots);
      api.clearTimeslots(this.$store.getters.currentSeason.id, timeslots).then(() => {
        this.makeToast("success", this.$t("deleted-timeslots-length-timeslots", [timeslots.length]));
        this.deleteVisibleModal = false;
        this.resetFilters();
        this.fetchData();
      });
    },
    resetKey() {
      setTimeout(() => {
        console.log("KeyBusy is now false");
        this.keyBusy = false;
      }, 1500);
    },
    deleteSelected(num) {
      this.hideTooltip();
      console.log("Delete Selected", this.selectedCounts);
      var str = this.$t("Timeslot.timeslots");
      var length = this.selectedCounts.timeslots.length;
      var ids = this.selectedCounts.timeslot_ids;
      if (num == 1) {
        str = this.$t("item_string.games");
        length = this.selectedCounts.games.length;
        ids = this.selectedCounts.game_ids;
      }
      setTimeout(() => {
        var x = window.confirm(
          this.$t("are-you-sure-you-want-to-delete") + length + " " + str + this.$t("this-cannot-be-undone"),
        );
        if (!x) {
          return;
        }
        console.log("IDS", ids);
        api.clearTimeslots(this.$store.getters.currentSeason.id, ids).then(() => {
          this.makeToast("success", this.$t("deleted-ids-length", [ids.length]) + str);
          this.resetKey();
          this.deleteVisibleModal = false;
          this.refresh();
          if (num === 0) {
            this.selectedEventIDs = this.selectedCounts.game_ids;
          } else {
            this.selectedEventIDs = this.selectedCounts.timeslot_ids;
          }
        });
      }, 250);
    },
    unscheduleSelected() {
      this.hideTooltip();
      var length = this.selectedCounts.games.length;
      var ids = this.selectedCounts.game_ids;
      console.log(ids);
      var x = window.confirm(
        this.$t("are-you-sure-you-want-to-unschedule") +
          length +
          this.$t("games-the-game-will-be-sent-to-the-reschedule-list-and-the-timeslot-will-be-marked-as-available"),
      );
      if (!x) {
        return;
      }
      api.unscheduleTimeslots(this.$store.getters.currentSeason.id, ids).then(() => {
        this.makeToast("info", this.$t("unscheduled") + length + this.$t("item_string.games"));
        this.deleteVisibleModal = false;
        this.resetFilters();
        this.refresh();
        this.selectedEventIDs = this.selectedCounts.timeslot_ids;
      });
    },
    refresh() {
      this.gameModal = false;
      this.activeEvent = null;
      this.clearSelected(0);
      this.clearSelected(1);
      this.pasting = false;
      this.fetchData();
      this.open = false;
    },
    copyTimeslots() {
      this.hideTooltip();
      console.log("Copy timeslots");
      console.log(this.weekTemplate, this.weekSelection.weeks);
      api
        .copyWeekTimeslots({
          season_id: this.$store.getters.currentSeason.id,
          start: this.weekTemplate.start,
          finish: this.weekTemplate.end,
          weeks: this.weekSelection.weeks,
        })
        .then(response => {
          console.log(response);
          this.fetchData();
          this.weekModal = false;
          this.makeToast("success", this.$t("copied-timeslots"));
          this.calendar.getApi().changeView("dayGridMonth", this.getApi().currentData.dateProfile.currentRange.end);
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    startWeek() {
      this.weekModal = true;
      var x = this.getApi();
      console.log(x.currentData.dateProfile.currentRange);
      this.weekTemplate = x.currentData.dateProfile.currentRange;
    },
    getTimeslotEvent(id) {
      var result = null;
      this.timeslots.forEach(t => {
        if (t.id == id) {
          result = t;
        }
      });
      return result;
    },
    hideTooltip() {
      this.showTooltip = false;
      this.allowTooltip = false;
      this.$forceUpdate();
      setTimeout(() => {
        this.allowTooltip = true;
      }, 1250);
    },
    handleEventDrop(eventDropInfo) {
      this.hideTooltip();
      console.log("🔴 Event Drop", eventDropInfo, eventDropInfo.event.start, eventDropInfo.event.end);
      var d = eventDropInfo.delta;
      var t = this.getTimeslotEvent(eventDropInfo.event.extendedProps.timeslot_id);
      var events = [];
      if (this.selectedEvents.length) {
        this.selectedEvents.forEach(e => {
          // console.log("😃 Start: " + e)
          console.log("Delta", d);
          // console.log("🤲🏽 New Start: " + e)
          var start = e.start;
          var end = e.end;

          var ns = this.$moment(start)
            .add(d.days, "days")
            .add(d.hours, "hours")
            .add(d.milliseconds / 60000, "minutes")
            .add(d.months, "months")
            .toDate();
          var ne = this.$moment(end)
            .add(d.days, "days")
            .add(d.hours, "hours")
            .add(d.milliseconds / 60000, "minutes")
            .add(d.months, "months")
            .toDate();

          console.log("🕓 " + start.toLocaleString() + " ---> " + ns.toLocaleString());
          console.log("💎 " + end.toLocaleString() + " ---> " + ne.toLocaleString());

          events.push({
            id: e.timeslot_id,
            start: ns,
            finish: ne,
          });
        });
      } else {
        events = [
          {
            id: eventDropInfo.event.extendedProps.timeslot_id,
            start: eventDropInfo.event.start,
            finish: eventDropInfo.event.end,
          },
        ];
      }
      console.log("EVENTS", events);
      api
        .updateMultipleTimeslots(events)
        .then(response => {
          console.log("Response", response);
          var d = response.data;
          if (d.bad != 0 && d.good != 0) {
            this.makeToast(
              "info",
              this.$t("updated-response-data-good-timeslot-s-response-data-bad-not-updated-due-to-conflict", [
                response.data.good,
                response.data.bad,
              ]),
            );
          } else if (d.bad == 0) {
            this.makeToast("success", this.$t("updated-response-data-good-timeslot-s", [response.data.good]));
          } else {
            this.makeToast(
              "warn",
              this.$t("could-not-update-response-data-bad-timeslot-s-due-to-conflict", [response.data.bad]),
            );
          }
          d.results.forEach(z => {
            console.log("Find: ", z);
            this.timeslots.forEach((t, i) => {
              if (z.id == t.id) {
                console.log("✅ Found " + z.id + " at index " + i);
                this.timeslots.splice(i, 1);
                this.timeslots.push(z);
              }
            });
          });
          this.setFilteredTimeslots();
          this.clearSelected(0);
          this.clearSelected(1);
          this.$forceUpdate();
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    pasteTimeslots(dateInfo) {
      console.log("Paste on ", dateInfo);
      if (!this.selectedEvents.length) return;

      const date1 = Date.parse(this.selectedEvents[0].start);
      const date2 = Date.parse(dateInfo.date);
      console.log(date1, date2);
      const diffTime = date2 - date1;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      console.log(diffTime, diffDays);
      api
        .pasteTimeslots(this.selectedEventIDs, diffDays)
        .then(response => {
          console.log("Response", response);
          this.makeToast("success", this.$t("pasted-response-data-count-timeslot-s", [response.data.count]));
          this.checkEndDate(response.data.last);
          this.fetchData();
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    fetchData() {
      console.log("FetchData ✨");
      if (!this.$store.getters.currentSeason) {
        console.log("NO CS....");
        setTimeout(() => {
          this.fetchData();
        }, 500);
        return;
      }
      api
        .getSeasonItems(this.$store.getters.currentSeason.id)
        .then(response => {
          this.timeslots = response.data;
          this.isLoading = false;
          this.setFilteredTimeslots();
        })
        .catch(e => {});
    },
    handleDateClick(dateInfo) {
      console.log("🎾 HandleDateClick ", dateInfo);
      if (this.pasting) {
        console.log("Should paste!");
        this.pasteTimeslots(dateInfo);
        return;
      }
      if (this.selecting) {
        console.log("Selecting, return");
        return;
      }
      if (this.selectedEventIDs.length) {
        this.clearSelected(0);
        this.clearSelected(1);
        return;
      }
      if (dateInfo.view.type == "dayGridMonth") {
        if (this.selectedEventIDs.length) {
          return;
        }
        this.getApi().changeView("timeGridWeek", dateInfo.date);
      } else {
        if (this.selectedEventIDs.length) {
          return;
        }
        if (!this.template.venue) {
          this.makeToast("info", this.$t("select-a-venue-first"));
          return;
        }
        if (!this.template.surface_ids.length) {
          this.makeToast("info", this.$t("select-a-surface-first"));
          return;
        }
        if (this.template.venue) {
          console.log("💎 DATE INFO ");
          console.log(dateInfo);
          var x = this.$moment(dateInfo.date);
          x.add(this.template.length, "minutes");
          this.template.start = x._i;
          this.template.finish = x._d;
          this.createTimeslot();
        }
      }
    },
    deleteTimeslot(timeslot_id) {
      this.hideTooltip();
      this.pasting = false;
      api
        .deleteTimeslot(timeslot_id)
        .then(() => {
          this.makeToast("success", this.$t("deleted-timeslot"));
          this.fetchData();
        })
        .catch(() => {
          this.makeToast("error", this.$t("Toast.error.delete_timeslot"));
        });
    },
    createTimeslot() {
      var count = this.template.surface_ids.length;
      console.log("\n\n CREATE " + count + " TIMESLOTS");
      this.hideTooltip();
      this.template.surface_ids.forEach(sid => {
        var timeslot = {
          venue_id: this.template.venue.id,
          divisions: this.template.divisions,
          start: this.template.start,
          finish: this.template.finish,
          surface_id: sid,
          season_id: this.$store.getters.currentSeason.id,
          is_practice: this.template.is_practice,
          is_game: this.template.is_game,
          is_reserved: this.template.is_reserved,
        };
        console.log(timeslot);
        api
          .createTimeslot(timeslot)
          .then(response => {
            console.log("⭐️ ⭐️ ⭐️ Created", response.data);
            const t = response.data;
            const s = new Date(t.start);
            this.timeslots.push(response.data);
            this.checkEndDate(s);
          })
          .catch(e => {
            console.log("Error...");
            console.log(e);
          })
          .finally(() => {
            this.setFilteredTimeslots();
            this.hideTooltip();
          });
      });
    },
    checkEndDate(d) {
      console.log("🔵 Check end: " + d, this.sconfig.endDate);
      if (d && this.sconfig.startDate && this.sconfig.endDate) {
        var slot = this.$moment(d);
        var start = this.$moment(this.sconfig.realStart).startOf("day");
        var end = this.$moment(this.sconfig.realEnd).endOf("day");
        console.log("After / Before: " + slot.isAfter(end) + " / " + slot.isBefore(start));
        if (slot.isAfter(end)) {
          setTimeout(() => {
            this.endSlotDate = d;
            this.endDialog = true;
          }, 1000);
        } else if (slot.isBefore(start)) {
          setTimeout(() => {
            this.endSlotDate = d;
            this.endDialog = true;
          }, 1000);
        }
      }
    },
    handleDateSelect(dateInfo) {
      this.selecting = true;
      setTimeout(() => {
        this.selecting = false;
      }, 100);
      console.log("HandleDateSelect", dateInfo.jsEvent);
      console.log("⭐️ " + dateInfo.start + " ---> " + dateInfo.end);
      dateInfo.jsEvent.stopPropagation();
      dateInfo.jsEvent.preventDefault();
      this.hideTooltip();
      this.timeslotEvents.forEach(e => {
        if (this.selectDateWithinRange(e.start, dateInfo.start, dateInfo.end)) {
          console.log(e.start);
          this.selectedEventIDs.push(e.timeslot_id);
          this.toggleHighlight(e.timeslot_id, true);
        }
      });
      dateInfo.view.calendar.unselect();
    },

    handleEventClick(clickInfo) {
      var tid = clickInfo.event.extendedProps.timeslot_id;
      var index = this.selectedEventIDs.indexOf(tid);
      if (index < 0) {
        this.selectedEventIDs.push(tid);
        this.toggleHighlight(tid, true);
      } else {
        console.log("Splice");
        this.selectedEventIDs.splice(index, 1);
        this.toggleHighlight(tid, false);
      }
      console.log(this.selectedEventIDs, this.selectedEvents);
    },
    toggleHighlight(tid, shouldHighlight) {
      this.timeslotEvents.forEach(t => {
        if (tid == t.timeslot_id) {
          t.classNames = shouldHighlight ? ["highlighted"] : [];
        }
      });
      this.calendarOptions.events = [];
      this.calendarOptions.events = this.timeslotEvents;
    },
    handleEvents(events) {
      this.currentEvents = events;
    },
    getText(t) {
      var title = "🕓 " + t.venue.name;
      var isPractice = !t.game && t.is_practice && !t.is_game;
      var isGame = !isPractice && !t.game && t.is_game && !t.is_practice;
      if (isPractice) {
        title = "🕓 ✏️ " + t.venue.name;
      } else if (isGame) {
        title = "🕓 ⛹️‍♀️ " + t.venue.name;
      }
      let description = this.$t("open-timeslot-less-than-br-greater-than");
      if (t.is_reserved) {
        title = "🔒🕓 " + t.venue.name;
        description = this.$t("reserved-timeslot-less-than-br-greater-than");
      }
      if (t.game) {
        title = "✔️ ⛹️‍♀️ " + t.game.summary;
        if (t.game.is_practice) {
          title = "✔️ ✏️" + t.game.home_name + this.$t("item_string.practice");
          title += "@" + t.venue.name;
        }
        if (t.game.is_practice) {
          description = this.$t("practice-with-icon") + t.game.visitor_name + "<br>";
        } else {
          description =
            this.$t("game-less-than-br-greater-than") + t.game.visitor_name + "@" + t.game.home_name + "<br>";
        }
      }
      description += t.venue.name + " <br> ";
      if (t.surface) {
        title += " - " + t.surface.name;
        description += t.surface.name + "<br>";
      }
      description +=
        this.$moment(t.startTime).format("LL") +
        " <br> " +
        this.$moment(t.startTime).format("hh:mm a") +
        " to " +
        this.$moment(t.endTime).format("hh:mm a");
      if (isPractice) {
        description += this.$t("less-than-br-greater-than-practice-only");
      } else if (isGame) {
        description += this.$t("less-than-br-greater-than-game-only");
      }

      if (isPractice) {
        title += this.$t("practice-only");
      } else if (isGame) {
        title += this.$t("game-only");
      }

      return { description: description, title: title };
    },
    setFilteredTimeslots() {
      var timeslots = this.filterTimeslots(
        this.timeslots,
        this.selectedTeams,
        this.selectedDivisions,
        this.selectedVenues,
        this.includeMultiDivision,
        this.includeGames,
        this.includeTimeslots,
        this.schedule_id,
        this.selectedSurfaces,
        null,
        null,
        this.practiceTimeslots,
        this.gameTimeslots,
        this.includePractices,
      );
      this.timeslotEvents = [];
      timeslots.forEach((t, i) => {
        var z = this.getText(t);
        var description = z.description;
        var title = z.title;
        if (this.calendar && this.getApi().view.type == "timeGridDay") {
          title = z.description.replace(/<br>/g, " - ");
        }

        var color = "";
        if (!t.divisions.length) {
          color = "grey";
        } else if (t.divisions.length == 1) {
          color = this.getSeasonDivision(t.divisions[0]).color;
        } else if (t.divisions.length > 1) {
          color = "grey";
        }
        if (t.game) {
          var d = this.getSeasonDivision(t.game.division_id);
          if (d) {
            color = d.color;
          }
        }
        if (t.is_reserved) {
          color = "black";
        }
        var g = t.game;
        if (!this.currentUser.upgraded && i % 3 == 0 && g) {
          title = this.$t("hidden-hidden");
          description = this.$t("hidden-item-upgrade-to-unlock");
          g = {
            home: { name: "HIDDEN" },
            visitor: { name: "HIDDEN" },
          };
        }
        this.timeslotEvents.push({
          title: title,
          description: description,
          backgroundColor: color,
          borderColor: color,
          start: new Date(t.start),
          end: new Date(t.finish),
          timeslot_id: t.id,
          has_game: t.has_game,
          divisions: t.divisions,
          surface_id: t.surface_id,
          venue_id: t.venue_id,
          game: g,
          is_game: t.is_game,
          is_practice: t.is_practice,
          is_reserved: t.is_reserved,
        });
      });
      this.calendar = this.$refs.fullCalendar;
      this.timeslotEvents.forEach(e => {
        if (this.selectedEventIDs.includes(e.timeslot_id)) this.toggleHighlight(e.timeslot_id, true);
      });
      this.calendarOptions.events = this.timeslotEvents;
      if (this.schedule_id) {
        var s = null;
        this.timeslotEvents.forEach(e => {
          if (!s && e.has_game) {
            s = e.start;
          }
        });
        console.log("FIRST --> ", s);
        this.calendarOptions.initialDate = s;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.currentSeason && !this.currentSeason.venues.length) {
        console.log("No venues!");
        alert(this.$t("you-need-to-create-a-venue-first-youll-be-redirected-back-here-once-you-finish"));
        this.goRouter("/venues/new?return=" + window.location.pathname + window.location.search);
        return;
      }
    }, 1500);

    if (this.currentUser) {
      this.calendarOptions.firstDay = this.currentUser.first_day || 0;
      this.calendarOptions.hiddenDays = this.currentUser.hidden;
    }

    this.schedule_id = this.getURLParam("schedule_id");

    const sd = this.getURLParam("sd");
    const td = this.getURLParam("td");

    console.log("SD param:", sd);
    console.log("TD param:", td);

    if (td) {
      this.sconfig.division_id = td;
      this.sconfig.is_tournament = true;
    } else {
      this.sconfig.division_id = sd;
    }

    if (this.sconfig.division_id) {
      if (this.sconfig.is_tournament) {
        this.tournamentDialog = true;
      } else {
        this.configDialog = true;
      }

      if (!this.isProduction) {
        let val = new Date("6/1/23");
        this.sconfig.realStart = val;
        this.sconfig.startDate = this.$moment(val).format("MM-DD-YY");
        let z = new Date("6/14/23");
        this.sconfig.realEnd = z;
        this.sconfig.endDate = this.$moment(z).format("MM-DD-YY");
      }
    }

    if (this.schedule_id) {
      this.includeTimeslots = false;
      this.showFilters = true;
    }

    window.analytics.page();
    this.fetchData();
    this.template.venue = this.$store.getters.currentSeason.venues[0];
    if (this.template.venue && this.template.venue.surfaces.length) {
      this.template.surface_ids = [this.template.venue.surfaces[0].id];
    }
    this.resetFilters();
    setTimeout(() => {
      this.calendar = this.$refs.fullCalendar;
      console.log(this.calendar);
      if (!this.calendar) {
        setTimeout(() => {
          this.calendar = this.$refs.fullCalendar;
        }, 1000);
      }
    }, 500);

    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    document.removeEventListener("keyup", this.tryDeleteKey, false);
    document.addEventListener("keyup", this.tryDeleteKey, false);

    document.addEventListener("mousedown", event => {
      var tc = event.target.classList;
      if (tc.contains("fc-daygrid-event") || tc.contains("fc-event-title")) {
        this.hideTooltip();
      }
    });

    document.addEventListener("mousemove", event => {
      if (this.showTooltip && (this.$route.name.includes("Calendar") || this.$route.name.includes("Master"))) {
        this.tooltipPosition.left = event.x - 125 + "px";
        if (event.x + 170 >= window.innerWidth) {
          this.tooltipPosition.left = event.x - 250 + "px";
        }
        this.tooltipPosition.top = event.y - 175 + "px";
        this.$forceUpdate();
      }
    });
  },
  watch: {
    showFilters: function(val) {
      if (val) {
        localStorage.setItem("showFilters", val);
      } else {
        localStorage.removeItem("showFilters");
      }
    },
    "template.length": function(val) {
      console.log("New length: " + val);
      localStorage.setItem("calendarInterval", val);
      setTimeout(() => {
        this.calendar.$emit("reload-events");
        this.$forceUpdate();
      }, 1000);
    },
    "sconfig.mode": function(val) {
      if (val == 1) {
        this.sconfig.style = 1;
      }
    },
    "sconfig.division_id": function(val) {
      if (val) {
        this.division = this.getArrayObjectID(this.currentSeason.divisions, this.sconfig.division_id);
        if (this.division.is_across) {
          console.log("ACROSS DIVS", this.division.across_divisions);
          this.a1 = this.getSeasonDivision(this.division.across_divisions[0]);
          this.a2 = this.getSeasonDivision(this.division.across_divisions[1]);
          if (this.a1.teams.length > this.a2.teams.length) {
            var x = this.a1;
            this.a1 = this.a2;
            this.a2 = x;
          }
        }
      } else {
        this.division = null;
        this.a1 = null;
        this.a2 = null;
      }
    },
    timeslots: function() {
      this.setFilteredTimeslots();
    },
    "template.venue": function() {
      if (this.template.venue && this.template.venue.surfaces && this.template.venue.surfaces[0]) {
        this.template.surface_ids = [this.template.venue.surfaces[0].id];
      }
    },
  },
};
</script>

<template>
  <div v-if="isLoading" class="isLoadingDiv">
    <ProgressSpinner />
  </div>

  <div v-else class="p-grid" id="cal">
    <ScheduleConfigurationDialogs
      :configDialog="configDialog"
      :toggleConfigDialog="toggleConfigDialog"
      :configAdditionalDialog="configAdditionalDialog"
      :toggleAdditionalConfigDialog="toggleAdditionalConfigDialog"
      :sconfig="sconfig"
      :windowWidth="windowWidth"
      :setStartDate="setStartDate"
      :setEndDate="setEndDate"
      :weeksNeeded="weeksNeeded"
      :division="division"
      :seasonDates="seasonDates"
      :teamCount="teamCount"
      :a1="a1"
      :a2="a2"
      :itemsPerTeam="itemsPerTeam"
      :slotsNeeded="slotsNeeded"
      :slotsAvailable="slotsAvailable"
      :additionalNeeded="additionalNeeded"
      :configValid="configValid"
      :nextSchedule="nextSchedule"
      :cancelSchedule="cancelSchedule"
      :venueBalanceDialog="venueBalanceDialog"
      :showVenueBalanceWindowInfo="showVenueBalanceWindowInfo"
      :toggleVenueBalanceDialog="toggleVenueBalanceDialog"
      :showVenueBalanceWindow="showVenueBalanceWindow"
      :scheduleDialog="scheduleDialog"
      :toggleScheduleDialog="toggleScheduleDialog"
      :scheduleBusy="scheduleBusy"
      :submitSchedule="submitSchedule"
      :oldDates="oldDates"
    />

    <TournamentConfigurationDialogs
      :tournamentDialog="tournamentDialog"
      :tournamentAdditionalDialog="tournamentAdditionalDialog"
      :tournamentConfig="sconfig"
      :cancelTournament="cancelSchedule"
      :oldDates="oldDates"
      :setStartDate="setStartDate"
      :setEndDate="setEndDate"
      :windowWidth="windowWidth"
      :slotsNeeded="slotsNeeded"
      :additionalNeeded="additionalNeeded"
      :slotsAvailable="slotsAvailable"
      :teamCount="teamCount"
      :tournamentValid="tournamentValid"
      :nextDialog="nextSchedule"
      :scheduleBusy="scheduleBusy"
      :tournamentScheduleDialog="tournamentScheduleDialog"
      :toggleTournamentConfigDialog="toggleTournamentConfigDialog"
      :toggleTournamentDialog="toggleTournamentDialog"
      :submitTournament="submitSchedule"
    />

    <div
      class="p-col-12"
      v-if="!showSidebar"
      style="background: lightyellow; border: 1px solid rbga(0,0,0,0.2); border-radius: 10px; width: 400px; margin: 5px auto"
    >
      {{ $t("sidebar-is-currently-hidden") }} &nbsp; &nbsp;
      <Button :label="$t('show-sidebar')" @click="toggleSidebar" class="p-button p-button-sm p-button-secondary" />
    </div>
    <div class="p-col-3" v-show="showSidebar" v-if="$store.getters.currentSeason" style="position: relative">
      <Button
        style="position: absolute; left: 10px; top: 0px; font-size: 1.2em"
        class="dsButton"
        v-tooltip.right="'Back to Dashboard'"
        @click="goRouter('/')"
      >
        <font-awesome-icon style="color: white" icon="arrow-left" :label="$t('back')"></font-awesome-icon>&nbsp;
        <font-awesome-icon class="menuIcon" :icon="['fal', 'home-alt']" />
      </Button>
      <div v-if="!$store.getters.currentSeason.venues.length">
        <h2 class="title p-mt-5 p-mb-3">
          {{ $t("you-must-create-a-venue-before-creating-timeslots") }}
        </h2>
        <Button
          :label="$t('Button.create_venue')"
          @click="goRouter('/venues/new?return=/calendar')"
          class="p-button p-button-lg"
        />
      </div>
      <div class="" v-else>
        <div v-if="selectedEvents.length">
          <GameModal
            :master="false"
            :teams="gameTeams"
            :active="gameModal"
            :iscalendar="true"
            :input="activeEvent"
            :schedule="null"
            v-on:hide="toggleGameModal"
            v-on:refresh="refresh"
            v-on:updated="refresh"
            v-on:gamecreated="refresh"
            v-on:deletegame="refresh"
            v-on:unschedulegame="refresh"
          ></GameModal>
          <!-- GAMES -->
          <div v-if="selectedCounts.games.length" class="p-mb-5 p-mt-5">
            <br />
            <h1 class="title is-4">
              {{ $t("selected-games-selectedcounts-games-length", [selectedCounts.games.length]) }}
            </h1>
            <div class="p-grid" id="actionButtons">
              <div class="p-col-12" v-if="selectedCounts.games.length == 1">
                <Button class="p-button-blue p-button-lg p-my-1" @click="toggleGameModal(1)">
                  {{ $t("edit-game") }}
                </Button>
              </div>
              <div class="p-col-12">
                <Button class="p-button-orange p-button-lg p-my-1" @click="unscheduleSelected()">
                  <font-awesome-icon style="color: white" :icon="['far', 'undo']"></font-awesome-icon>&nbsp;{{
                    $t("send-to-unscheduled-list")
                  }}
                </Button>
              </div>
              <div class="p-col-12">
                <Button class="p-button-secondary p-my-1" @click="openModal('shift', 1)"
                  ><font-awesome-icon style="color: white" :icon="['fal', 'clock']"></font-awesome-icon>&nbsp;{{
                    $t("shift-times")
                  }}
                </Button>
              </div>
              <div class="p-col-12" v-if="selectedCounts.games.length == 2">
                <Button class="p-button-secondary p-my-1" @click="swapTimeslots"
                  ><font-awesome-icon style="color: white" :icon="['fal', 'clock']"></font-awesome-icon>&nbsp;{{
                    $t("swap-timeslots")
                  }}
                </Button>
              </div>
              <div class="p-col-6">
                <Button class="p-button-sm p-button-danger p-button-text" @click="deleteSelected(1)">
                  <font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon>&nbsp;
                  {{ $t("delete-selectedcounts-games-length-games", [selectedCounts.games.length]) }}
                </Button>
              </div>
              <div class="p-col-6">
                <Button
                  class="p-button-sm p-button-text"
                  v-tooltip="'Unselect all timeslots. They will not be deleted.'"
                  @click="clearSelected(0)"
                >
                  <font-awesome-icon :icon="['far', 'hand-peace']"></font-awesome-icon>&nbsp;{{
                    $t("unselect-selectedcounts-games-length-games", [selectedCounts.games.length])
                  }}
                </Button>
              </div>
            </div>
          </div>

          <!-- TIMESLOTS 🕓 -->
          <div v-if="selectedCounts.timeslots.length" class="p-mt-5">
            <br />
            <h1 class="title is-4">
              {{ $t("selected-timeslots-selectedcounts-timeslots-length", [selectedCounts.timeslots.length]) }}
            </h1>
            <p v-if="selectedCounts.timeslots.length > 1">
              {{
                $t("drag-and-drop-on-calendar-to-update-all-selected-timeslots-or-use-the-buttons-below-to-manage-them")
              }}
            </p>
            <br />
            <div v-if="!pasting" class="p-grid" id="actionButtons">
              <div class="p-col-12" v-if="selectedCounts.timeslots.length == 1">
                <Button class="p-button-blue p-button-lg p-my-1" @click="toggleGameModal(0)">
                  {{ $t("create-game-using-timeslot") }}
                </Button>
              </div>
              <div class="p-col-12">
                <Button class="p-button-blue p-button-lg p-my-1" @click="openModal('copy', 0)">
                  <font-awesome-icon style="color: white" :icon="['far', 'copy']"></font-awesome-icon>&nbsp;{{
                    $t("copy-selected-until-date")
                  }}
                </Button>
              </div>
              <div class="p-col-12">
                <Button class="p-button-blue p-button-lg p-my-1" @click="pasting = true">
                  <font-awesome-icon style="color: white" :icon="['far', 'copy']"></font-awesome-icon>&nbsp;{{
                    $t("paste-on-date-s")
                  }}
                </Button>
              </div>
              <div class="p-col-12">
                <Button class="p-button-secondary p-my-1 p-button-lg" @click="openModal('update', 0)"
                  ><font-awesome-icon style="color: white" :icon="['fal', 'cog']"></font-awesome-icon
                  >{{ $t("more-actions") }}
                </Button>
              </div>
              <div class="p-col-6">
                <Button class="p-button-sm p-button-danger p-button-text" @click="deleteSelected(0)">
                  <font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon>&nbsp;{{
                    $t("delete-selectedcounts-timeslots-length-timeslots", [selectedCounts.timeslots.length])
                  }}
                </Button>
              </div>
              <div class="p-col-6">
                <Button
                  class="p-button-sm p-button-text"
                  v-tooltip="'Unselect all timeslots. They will not be deleted.'"
                  @click="clearSelected(1)"
                >
                  <font-awesome-icon :icon="['far', 'hand-peace']"></font-awesome-icon>&nbsp;{{
                    $t("unselect-selectedcounts-timeslots-length-timeslots", [selectedCounts.timeslots.length])
                  }}
                </Button>
              </div>
            </div>
            <div v-else>
              <h1 class="title is-3">
                {{
                  $t("click-date-s-to-paste-selectedcounts-timeslots-length-timeslots", [
                    selectedCounts.timeslots.length,
                  ])
                }}
              </h1>
              <Button class="p-button-blue p-button-lg p-my-1" @click="finishPasting">
                {{ $t("done-pasting") }}
              </Button>
            </div>
          </div>
          <div class="p-grid p-my-3">
            <div class="p-col-6 p-text-center nopadding">
              <Button class="p-button-secondary" @click="selectAll">
                <font-awesome-icon class="cursorpointer" :icon="['far', 'hand-pointer']" />&nbsp;{{ $t("select-all") }}
              </Button>
            </div>
            <div class="p-col-6 p-text-center nopadding">
              <Button class="p-button-secondary" @click="selectVisible">
                <font-awesome-icon class="cursorpointer" :icon="['far', 'hand-pointer']" />&nbsp;{{
                  $t("select-visible")
                }}
              </Button>
            </div>
          </div>
          <manage-timeslots-modal
            :sconfig="sconfig.startDate ? sconfig : null"
            :mtype="modalType"
            :inputaction="action"
            @hide="hideModal"
            @refresh="refresh"
            @check="checkEndDate"
            :open="open"
            @delete="deleteSelected(1)"
            :fullitems="modalType == 1 ? selectedCounts.games : selectedCounts.timeslots"
            :items="modalType == 1 ? selectedCounts.game_ids : selectedCounts.timeslot_ids"
          />
          <br />
        </div>
        <div v-else style="font-size: 12px" @click="showTooltip = false">
          <h2 class="title is-5" @click="fetchData">
            <span v-if="timeslotEvents.length != timeslots.length">
              <span class="big">{{ timeslotEvents.length }}</span> &nbsp;of&nbsp;
              <span class="big">{{ timeslots.length }}</span>
              <br />
              {{ $t("filtered-schedulethings", [scheduleThings]) }}
            </span>
            <span v-else>
              <span class="big">{{ timeslots.length }}&nbsp;</span>
              <br />
              {{ $t("available-schedulethings", [scheduleThings]) }}
            </span>
          </h2>
          <div class="p-text-left p-my-3" v-if="timeslots.length">
            <div class="p-grid p-my-3">
              <div class="p-col-12 p-text-center">
                <a @click="settingsModal = true"> {{ $t("edit-calendar-settings") }} </a>
              </div>
              <div class="p-col-6 p-text-center">
                <Button
                  class="p-button-secondary"
                  @click="selectAll"
                  v-tooltip.right="'Select all games, practices, and timeslots in the season'"
                >
                  <font-awesome-icon class="cursorpointer" :icon="['far', 'hand-pointer']" /> &nbsp;
                  {{ $t("select-all") }}
                </Button>
              </div>
              <div
                class="p-col-6 p-text-center"
                v-tooltip.right="
                  'Select the games, practices, and timeslots that are visible in the current calendar view'
                "
              >
                <Button class="p-button-secondary" @click="selectVisible">
                  <font-awesome-icon class="cursorpointer" :icon="['far', 'hand-pointer']" /> &nbsp;
                  {{ $t("select-visible") }}
                </Button>
              </div>
              <div class="p-col-6 p-text-center">
                <Button class="p-button p-button-warning" @click="showFilters = !showFilters">
                  <span v-if="showFilters">
                    <font-awesome-icon :icon="['fal', 'arrow-up']"></font-awesome-icon>&nbsp;{{ $t("hide-filters") }}
                  </span>
                  <span v-else>
                    <font-awesome-icon icon="arrow-down"></font-awesome-icon>&nbsp;{{ $t("show-filters") }}
                  </span>
                </Button>
              </div>
              <div class="p-col-6 p-text-center">
                <Button class="p-button p-button-secondary" @click="toggleSidebar">
                  <font-awesome-icon :icon="['far', 'hand-peace']"></font-awesome-icon>&nbsp;{{ $t("hide-sidebar") }}
                </Button>
              </div>
            </div>

            <!-- FILTERBOX -->
            <div v-if="showFilters" class="p-mt-3" id="timeslotFilterBox">
              <h2 class="title is-4 p-text-center p-mt-2">{{ $t("calendar-filters") }}</h2>
              <div class="p-grid p-mt-1">
                <div class="p-col-12 p-text-center">
                  <Button class="p-button-secondary" @click="resetFilters">
                    <font-awesome-icon style="color: white" :icon="['far', 'undo']"></font-awesome-icon>&nbsp;{{
                      $t("reset-filters")
                    }}
                  </Button>
                </div>
                <div class="p-col-12" v-if="currentSeason.schedules.length">
                  <div class="title is-6 p-mb-5 p-text-center">{{ $t("AppMenu.schedule") }}</div>
                  <Dropdown
                    :options="currentSeason.schedules"
                    optionLabel="name"
                    optionValue="id"
                    :placeholder="$t('choose-schedule')"
                    style="width: 100%; font-size: 12px"
                    v-model="schedule_id"
                    @input="setFilteredTimeslots"
                    :showClear="true"
                  />
                  <div v-if="schedule_id" class="p-text-center p-my-3">
                    <Button
                      class="button--small"
                      @click="goRouter(`/schedules/${schedule_id}`)"
                      :label="$t('open-game-list')"
                    />
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="title is-6 p-mb-5">{{ $t("show") }}</div>
                  <div class="mb-2">
                    <a @click="toggleAll(4)"> {{ $t("toggle-all") }} </a>
                  </div>
                  <div class="p-field-checkbox">
                    <Checkbox v-model="includeGames" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("item_string.games") }} </label>
                  </div>
                  <div class="p-field-checkbox">
                    <Checkbox v-model="includePractices" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("item_string.practices") }} </label>
                  </div>
                  <div class="p-field-checkbox">
                    <Checkbox v-model="includeTimeslots" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("open-timeslots") }} </label>
                  </div>
                  <div class="p-field-checkbox" v-if="includeTimeslots">
                    <Checkbox v-model="includeMultiDivision" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("multi-division-timeslots") }} </label>
                  </div>
                  <div class="p-field-checkbox" v-if="includeTimeslots">
                    <Checkbox v-model="practiceTimeslots" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("practice-timeslots") }} </label>
                  </div>
                  <div class="p-field-checkbox" v-if="includeTimeslots">
                    <Checkbox v-model="gameTimeslots" @change="setFilteredTimeslots" :binary="true" />
                    <label> {{ $t("game-timeslots") }} </label>
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="title is-6 p-mb-1">{{ $t("AppMenu.divisions") }}</div>
                  <div class="mb-2">
                    <a @click="toggleAll(0)"> {{ $t("toggle-all") }} </a>
                  </div>
                  <div class="p-field-checkbox" v-for="t in $store.getters.currentSeason.divisions" :key="t.id">
                    <Checkbox
                      :id="t.name"
                      :name="t.name"
                      :value="t.id"
                      @change="setFilteredTimeslots"
                      v-model="selectedDivisions"
                    />
                    <label :for="t.name">{{ t.name }} </label>
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="title is-6 p-mb-1">{{ $t("Team.teams") }}</div>
                  <div class="mb-2">
                    <a @click="toggleAll(5)"> {{ $t("toggle-all") }} </a>
                  </div>
                  <div class="p-field-checkbox" v-for="t in $store.getters.currentSeason.teams" :key="t.id">
                    <Checkbox
                      :id="t.name"
                      :name="t.name"
                      :value="t.id"
                      @change="setFilteredTimeslots"
                      v-model="selectedTeams"
                    />
                    <label :for="t.name">{{ t.name }} </label>
                  </div>
                </div>
                <div class="p-col-6">
                  <div class="title is-6">{{ $t("AppMenu.venues") }}</div>
                  <div class="mb-2">
                    <a @click="toggleAll(1)"> {{ $t("toggle-all") }} </a>
                  </div>
                  <div class="p-field-checkbox" v-for="t in $store.getters.currentSeason.venues" :key="t.id">
                    <Checkbox
                      :id="t.name"
                      :name="t.name"
                      :value="t.id"
                      @change="setFilteredTimeslots"
                      v-model="selectedVenues"
                    />
                    <label :for="t.name">{{ t.name }} </label>
                  </div>
                </div>

                <div class="p-col-12">
                  <div class="title is-6">{{ $t("surfaces") }}</div>
                  <div class="mb-2">
                    <a @click="toggleAll(2)"> {{ $t("toggle-all") }} </a>
                  </div>
                  <div class="p-field-checkbox" v-for="t in currentSeasonSurfaces" :key="t.id">
                    <Checkbox
                      :id="t.name"
                      :name="t.name"
                      :value="t.id"
                      @change="setFilteredTimeslots"
                      v-model="selectedSurfaces"
                    />
                    <label :for="t.name">{{ t.name }} ({{ t.venue.name }}) </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- WIZARDBOX -->
          <div class="p-mt-3" id="wizardBox" v-if="sconfig.division_id">
            <div class="p-grid p-mt-1">
              <div class="p-col-12">
                <h3 class="title is-3">
                  <div
                    class="colorBall"
                    style="height: 1em; width: 1em; margin-top: -5px; margin-left: -1em; cursor: pointer"
                    @click="toggleConfigDialog(true)"
                    v-bind:style="{ background: division.color || '#FFFFFF' }"
                  />
                  {{ $t("AppMenu.scheduling") }}
                </h3>
                <div id="scheduleInfoBox" class="p-mt-2">
                  <ul style="list-style: circle; padding-left: 15%;">
                    <li>
                      {{
                        $t("division-name-sconfig-mode-0-games-practices-division-teams-length-teams", [
                          division.name,
                          sconfig.mode == 0 ? "Games" : "Practices",
                          division.teams.length,
                        ])
                      }}
                    </li>
                    <li>
                      {{
                        $t("sconfig-startdate-to-sconfig-enddate-seasondates-weeks-weeks", [
                          sconfig.startDate,
                          sconfig.endDate,
                          seasonDates.weeks,
                        ])
                      }}
                    </li>
                    <li>
                      {{ scheduleSummary }}
                    </li>
                    <!-- <li>
                      {{ slotsNeeded  ? parseInt(2 * slotsNeeded / division.teams.length) : '--' }} per team, {{ slotsNeeded }} total
                    </li> -->
                    <li>
                      {{
                        $t("slotsavailable-division-id-timeslots-available-slotsneeded-needed", [
                          slotsAvailable(division.id),
                          slotsNeeded,
                        ])
                      }}
                    </li>
                    <li v-if="additionalNeeded">
                      <strong
                        >{{
                          $t("math-ceil-slotsneeded-seasondates-weeks-timeslots-per-week-required", [
                            Math.ceil(slotsNeeded / seasonDates.weeks),
                          ])
                        }}
                      </strong>
                    </li>
                    <li v-else>
                      <strong style="color: green">{{ $t("you-have-enough-timeslots") }} </strong>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="p-col-12" id="calBoxButtons">
                <div>
                  <span v-if="additionalNeeded" style="font-size: 1.2em; color: darkred; font-weight: bold">
                    {{ $t("additionalneeded-more-timeslots-needed", [additionalNeeded]) }}
                  </span>
                </div>
                <Button
                  class="p-button-lg p-mb-2"
                  v-bind:class="{ 'p-button-text p-button-plain': additionalNeeded > 0 }"
                  @click="toggleScheduleDialog(true)"
                >
                  <font-awesome-icon class="cursorpointer" :icon="['fal', 'gem']" /> &nbsp;{{ $t("schedule-now") }}
                </Button>
                <div>
                  <Button class="p-button-sm p-button-text" @click="toggleConfigDialog(true)">
                    {{ $t("edit-settings") }}
                  </Button>
                  <Button
                    class=" p-button-secondary p-button-sm p-button-text"
                    @click="doLightbox('https://embed.mindstamp.io/embed/jxeNTpTPCEli')"
                  >
                    {{ $t("watch-tutorial") }}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <!-- SLOTBOX -->
          <div class="p-mt-3" id="timeslotCreateBox">
            <h2 class="title is-4 p-text-center p-mt-2">{{ $t("create-timeslot") }}</h2>
            <p>
              {{
                $t(
                  "click-a-date-to-add-timeslot-with-these-properties-select-calendar-timeslots-to-copy-them-until-a-date-shift-times-delete-etc",
                )
              }}
            </p>
            <div class="p-grid p-mt-1">
              <div class="p-col-6">
                <div class="title is-6">{{ $t("GameTable.column.venue") }}</div>
                <Dropdown
                  :options="$store.getters.currentSeason.venues"
                  optionLabel="name"
                  :placeholder="$t('select-copy-distance')"
                  style="width: 100%; font-size: 12px"
                  v-model="template.venue"
                />
              </div>
              <div class="p-col-6">
                <div class="title is-6">{{ $t("duration") }}</div>
                <Dropdown
                  :options="lengthOptions"
                  optionLabel="name"
                  optionValue="value"
                  :placeholder="$t('timeslot-duration')"
                  style="width: 100%; font-size: 12px"
                  v-model="template.length"
                />
              </div>
              <div class="p-col-6 p-text-left">
                <div class="title is-6">{{ $t("surface-title") }}</div>
                <div class="p-field-checkbox" v-for="v in template.venue.surfaces" :key="v.id">
                  <Checkbox :value="v.id" v-model="template.surface_ids" :name="v.name" />
                  <label :for="v.name"> {{ v.name }}</label>
                </div>
              </div>
              <div class="p-col-6 p-text-left">
                <div class="title is-6">{{ $t("can-use-divisions") }}</div>
                <div class="p-field-checkbox" v-for="v in $store.getters.currentSeason.divisions" :key="v.id">
                  <Checkbox :value="v.id" v-model="template.divisions" :name="v.name + '-canPlay'" />
                  <label :for="v.name + '-canPlay'">
                    <div
                      class="colorBall"
                      style="height: 1em; width: 1em; margin-top: -1px; cursor: pointer"
                      v-bind:style="{ background: v.color || '#FFFFFF' }"
                    />
                    {{ v.name }}
                  </label>
                </div>
                <div class="p-mt-2">
                  {{ $t("default") }} &nbsp;
                  <div
                    class="colorBall"
                    style="height: 1em; width: 1em; margin-top: -1px; cursor: pointer"
                    v-bind:style="{ background: 'grey' }"
                  />
                  {{ $t("Calendar.all_divisions") }}
                </div>
              </div>
              <div class="p-col-12 p-text-left">
                <div class="title is-6">{{ $t("timeslot-use") }}</div>
                <div class="p-grid">
                  <div class="p-col-4">
                    <div class="p-field-checkbox">
                      <Checkbox v-model="template.is_game" :binary="true" />
                      <label> {{ $t("item_string.games") }} </label>
                    </div>
                  </div>
                  <div class="p-col-4">
                    <div class="p-field-checkbox">
                      <Checkbox v-model="template.is_practice" :binary="true" />
                      <label> {{ $t("item_string.practices") }} </label>
                    </div>
                  </div>
                  <div
                    class="p-col-4"
                    v-tooltip="
                      'Reserved timeslots will not be used in scheduling. They must be un-reserved before being used.'
                    "
                  >
                    <div class="p-field-checkbox">
                      <Checkbox v-model="template.is_reserved" :binary="true" />
                      <label> {{ $t("item_string.reserved") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-grid p-mt-3" id="bottomSection">
            <div class="p-col-6">
              <Button class="p-button-secondary" @click="doLightbox('https://embed.mindstamp.io/embed/jxeNTpTPCEli')">
                <font-awesome-icon class="cursorpointer" :icon="['fal', 'play']" /> &nbsp;{{ $t("watch-tutorial") }}
              </Button>
            </div>
            <div class="p-col-6">
              <Button class="p-button-white" @click="toggleConfigDialog(true)">
                <font-awesome-icon class="cursorpointer" :icon="['fal', 'gem']" /> {{ $t("new-schedule") }}
              </Button>
            </div>
            <div class="p-col-12 p-text-center">
              <PapaParse @save="doBulk" item="timeslot"></PapaParse>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :header="$t('adjustScheduleHeader')"
      :visible.sync="endDialog"
      :style="{ maxWidth: '600px' }"
      :modal="true"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="min-height: 300px">
        <p>
          {{ $t("you-created-a-timeslot-on") }} <strong> {{ endSlotDateFriendly }}</strong>
          {{ $t("which-is-outside-of-your-schedules-bounded-dates-of") }}

          <strong> {{ sconfig.startDate }} - {{ sconfig.endDate }}</strong
          >. <br /><br />{{ $t("this-wont-count-towards-eligible-timeslots-for-this-schedule") }} <br /><br />
          {{ $t("do-you-want-to-edit-your-schedule-dates-to-include-this-timeslot-on") }}
          <strong> {{ endSlotDateFriendlyPlus }}</strong>
          ?
        </p>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg" :label="$t('yes-adjust-end-date')" @click="adjustEndDate" />
        </div>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg p-button-text" :label="$t('no-dont-adjust-date')" @click="clearEndDialog" />
        </div>
      </div>
    </Dialog>
    <Dialog
      :header="$t('delete-all-timeslots')"
      :visible.sync="deleteAllModal"
      :style="{ maxWidth: '600px' }"
      :modal="true"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="min-height: 300px">
        <p>
          {{ $t("this-will-delete-each-of-this-seasons") }}
          <strong>{{ $t("timeslotevents-length-timeslots", [timeslotEvents.length]) }}</strong>
          {{ $t("that-do-not-have-a-scheduled-game-this-cannot-be-undone") }}
        </p>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg" :label="$t('cancel-and-return')" @click="deleteAllModal = false" />
        </div>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg p-button-danger" :label="$t('delete-all-timeslots')" @click="clearAllTimeslots" />
        </div>
      </div>
    </Dialog>
    <Dialog
      :header="$t('delete-filtered-timeslots')"
      :visible.sync="deleteVisibleModal"
      :style="{ maxWidth: '600px' }"
      :modal="true"
    >
      <div class="p-mt-3" style="min-height: 300px">
        <p>
          {{ $t("this-will-delete") }}
          <strong>{{ $t("timeslotevents-length-filtered-timeslots", [timeslotEvents.length]) }}</strong>
          {{ $t("that-do-not-have-a-scheduled-game-this-cannot-be-undone") }}
        </p>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg" :label="$t('cancel-and-return')" @click="deleteVisibleModal = false" />
        </div>
        <br />
        <div class="p-mt-3">
          <Button class="p-button-lg p-button-danger" @click="clearVisibleTimeslots">
            {{ $t("delete-timeslotevents-length-timeslots", [timeslotEvents.length]) }}
          </Button>
        </div>
      </div>
    </Dialog>
    <Dialog
      :header="$t('copy-week-template')"
      :visible.sync="weekModal"
      :style="{ maxWidth: '600px' }"
      :modal="true"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="min-height: 300px" v-if="weekInfo">
        <p>
          {{ $t("you-can-copy-this-week-timeslots-to-future-weeks-up-to-a-certain-date") }}
        </p>
        <br />
        <p>{{ $t("copy-this-weeks-timeslots-until") }}</p>
        <div>
          <Dropdown
            :options="weekInfo.options"
            optionLabel="name"
            :placeholder="$t('select-copy-distance')"
            style="width: 100%"
            class="p-mt-3"
            v-model="weekSelection"
          />
        </div>
        <div class="p-mt-3">
          <Button :disabled="!weekSelection" class="p-button-lg" :label="$t('submit')" @click="copyTimeslots" />
        </div>
      </div>
    </Dialog>
    <div class="p-col-9" :class="{ 'p-col-12': !showSidebar }">
      <div
        v-if="allowTooltip"
        v-show="showTooltip"
        id="tooltip"
        v-bind:style="tooltipPosition"
        style="pointer-events: none"
      >
        <div class="tooltipStringContent" v-html="tooltipString"></div>
      </div>
      <FullCalendar
        style="width: 100%; max-width: unset;"
        ref="fullCalendar"
        id="fullCalendar"
        class="demo-app-calendar"
        :options="calendarOptions"
      >
      </FullCalendar>
      <Dialog
        :header="$t('calendar-settings')"
        :visible.sync="settingsModal"
        :style="{ maxWidth: '600px', minWidth: '400px', width: 'auto' }"
        :modal="true"
        :closeOnEscape="false"
      >
        <div class="p-mt-3 p-grid" style="min-height: 300px">
          <div class="p-col-6">{{ $t("calendar-interval") }}</div>
          <div class="p-col-6">
            <Dropdown
              v-model="calendarSettings.interval"
              optionLabel="label"
              optionValue="value"
              :options="intervalOptions"
              style="width: 100%;"
            />
          </div>

          <div class="p-col-6">{{ $t("start-time") }}</div>
          <div class="p-col-6">
            <Dropdown
              v-model="calendarSettings.start"
              optionLabel="label"
              optionValue="raw"
              :options="timeOptions"
              style="width: 100%;"
            />
          </div>

          <div class="p-col-6">{{ $t("end-time") }}</div>
          <div class="p-col-6">
            <Dropdown
              v-model="calendarSettings.finish"
              optionLabel="label"
              optionValue="raw"
              :options="timeOptions"
              style="width: 100%;"
            />
          </div>
        </div>
        <div class="p-col-12 p-my-2">
          <Button @click="applySettings" class="p-button-secondary p-button-lg"> {{ $t("apply") }} </Button>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<style lang="scss">
.fc-timegrid-event {
  max-width: 200px !important;
}
.highlighted {
  border: 5px solid gold !important;
  // border-color: gold !important;
  padding: 0px !important;
}
h2 {
  margin: 0;
  font-size: 16px;
}

ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}

li {
  margin: 1.5em 0;
  padding: 0;
}

b {
  /* used for event dates/times */
  margin-right: 3px;
}

.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
  cursor: pointer;
}

.demo-app-sidebar-section {
  /* padding: 2em; */
  text-align: left;
}

.demo-app-main {
  flex-grow: 1;
  /* padding: 3em; */
}

.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}
</style>
<style lang="scss">
#timeslotFilterBox {
  background: lightyellow;
  border: 2px solid grey;
  border-radius: 10px;
  padding: 10px 15px;
  width: 100%;
  .p-inputtext {
    font-size: 14px !important;
  }
}

#wizardBox {
  background: white;
  border: 2px solid grey;
  border-radius: 10px;
  padding: 10px 15px;
  width: 100%;
}

#timeslotCreateBox {
  background: white;
  border: 2px solid grey;
  border-radius: 10px;
  padding: 10px 15px;
  width: 100%;

  .p-inputtext {
    font-size: 12px !important;
  }
}
</style>
<style scoped lang="scss">
.big {
  font-size: 2em;
}
#bottomSection {
  button {
    width: 100%;
    display: block;
    text-align: center;
    font-size: 1em;
    padding: 0.7rem 0.3rem;
  }
}

.constraintBox {
  label {
    font-weight: bold;
    font-size: 1em;
  }
  .p-inputnumber {
    font-size: 2em;
  }
}
#scheduleInfoBox {
  text-align: left;
  width: 90%;
  max-width: 300px;
  margin: 0 auto;
}

#tooltip {
  position: fixed;
  z-index: 2;
  width: 250px;
  height: 150px;
  font-size: 14px;
  background: black;
  color: white;
  padding: 5px 10px;
  font-weight: bold;
  line-height: 1.5em;
  border-radius: 5px;
  border: 5px solid black;
  box-shadow: 10 10px 20px rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
}

.tooltipStringContent,
.venueConfigurationContent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.p-field-checkbox {
  margin-bottom: 5px;
  line-height: 1.5em;
}

.p-field-radiobutton {
  max-width: 500px;
  line-height: 1.5em;
  text-align: left;
  align-items: center;
  margin: 0 auto;
  display: block;
}

#actionButtons {
  button {
    width: 100%;
    display: block;
    text-align: center;
  }
}

.p-multiselect {
  width: 100%;
  margin: 5px auto;
}
#balanceExampleTable th,
#balanceExampleTable tr,
#balanceExampleTable td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
  font-size: 1em;
}

#balanceExampleTable th {
  background-color: #d3d3d3;
}
</style>
